<template>
  <div v-if="daysLeft > 0"
    class="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 flex items-center shadow"
    role="alert"
  >
    <font-awesome-icon icon="exclamation-circle" class="h-5 w-5 text-yellow-500"></font-awesome-icon>
    <p class="ml-3 text-sm">
      ¡Atención! Te quedan <span class="font-bold">{{ daysLeft }}</span> día{{ daysLeft === 1 ? '' : 's' }} de prueba gratuita. Asegúrate de <a class="text-blue-500 underline hover:text-blue-700" @click="goToPlan">actualizar tu plan</a> antes de que expire.
    </p>
  </div>
</template>

<script>
export default {
  props: {
    daysLeft: {
      type: Number,
      required: true
    },
    targetCta: {
      type: String,
      required: true
    }
  },
  methods: {
    goToPlan (index) {
      this.$router.push(this.targetCta)
    }
  }
}
</script>
